import { IColumns } from '../../../../components/Table'

export type BusinessEntityDetailsUsersColumnKeys = 'id' | 'name' | 'idSf' | 'email' | 'actions'

export const columns: IColumns<BusinessEntityDetailsUsersColumnKeys>[] = [
  {
    id: 'id',
    label: 'ID',
  },
  {
    id: 'idSf',
    label: 'idSf',
  },
  {
    id: 'name',
    label: 'NAME',
  },
  {
    id: 'email',
    label: 'EMAIL',
  },
  {
    id: 'actions',
    label: 'ACTIONS',
  },
]
